import {Component} from '@angular/core';
import {OrganizationSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-index',
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss',
  standalone: false
})
export class IndexComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
